import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select";

export default class extends Controller{
  static targets = ['select']
  connect() {
    new TomSelect(this.selectTarget, {
      plugins: {
        'checkbox_options': {
          'checkedClassNames':   ['ts-checked'],
          'uncheckedClassNames': ['ts-unchecked'],
        },
        'change_listener': {},
        'clear_button':{
          'title': 'Remove all selected options',
          'html': function(data){
            return `<div class="${data.className}" title="${data.title}">&#65368;</div>`;
          } 
        }
      },
      render: {
        optgroup_header: function (data, escape) {
          return `<div class="optgroup-header"><button type="button" data-action="click->classrooms#clickHeader"> ${data.label}</button></div>`;
        }
      }
    })
  } 
  
  clickHeader(event) {
    event.preventDefault();
    const nodeList = event.target.parentElement.parentElement.querySelectorAll("[data-value]")
    const values = Array.from(nodeList).map(node => node.getAttribute("data-value"))
    Array.from(this.selectTarget.options).forEach(function (option) {
      if (values.includes(option.value)) {
        option.selected = true;
      } 
    });
    const evt = new Event("change");
    this.selectTarget.dispatchEvent(evt);

    event.target.ownerDocument.forms[0].requestSubmit()
  }

}